const login3 = (editor) => {

    editor.BlockManager.add('login3', {
        category: 'Login & Register',
        label: `
                    <svg  width="1.6vw" height="1.6vw" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>
                        <path d="M8.256 14a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Z"/>  
                    </svg>
                    <div class='gjs-fontFamily gjs-block-label'>Login With Logo</div>
                  `,
        attributes: {},
        content: `
        <div classtype='container-bg' class="pb-5 pt-3 vh-100 container-bg">
            <div class="d-sm-flex d-none justify-content-end align-items-center p-3">
                <img
                    src="https://dummyimage.com/150x60/dee2e6/6c757d.jpg"
                    alt="Logo3"
                    class="img-fluid ml-3 my-1 rounded-3"
                    width="150"
                    height="60"
                />
                <img
                    src="https://dummyimage.com/150x60/dee2e6/6c757d.jpg"
                    alt="Logo3"
                    class="img-fluid ml-3 my-1 rounded-3"
                    width="150"
                    height="60"
                />
            </div>
            <div
                classtype='login-container'
                class="m-auto login-container col-10 col-sm-8 col-md-6 col-lg-4 bg-white d-flex flex-column justify-content-center align-items-center p-3"
            >
                <img
                    src="https://dummyimage.com/450x300/dee2e6/6c757d.jpg"
                    alt="Logo"
                    class="img-fluid my-3"
                    width="450"
                    height="300"
                />
                <h1 classtype='login-container--text' class="my-3 w-75 text-center login-container--text">Log in to access the expert’s dashboard.
                </h1>
                <div class="input-group w-auto border-1 my-3">
                    <input pseudotype='login-container--input' statetype='login-container--input' classtype='login-container--input' type="text" required name="" class="form-control w-auto text-white login-container--input border-0" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1">
                    <span classtype='login-container--input_label' class="input-group-text login-container--input_label w-auto border-0"><i class="bi bi-person text-white"></i></span>
                </div>
                <div class="input-group w-auto border-1 mb-3">
                    <input pseudotype='login-container--input' statetype='login-container--input' classtype='login-container--input' type="password" required name="" class="form-control w-auto text-white login-container--input border-0" placeholder="Password" aria-label="Password" aria-describedby="basic-addon2">
                    <span classtype='login-container--input_label' class="input-group-text login-container--input_label w-auto border-0"><i class="bi bi-eye-slash text-white"></i></span>
                </div>                      
                <div class="form-group d-flex flex-column flex-sm-row justify-content-between w-auto my-3">
                    <div wablitype="checkboxes"  class="form-check form-check-inline">
                    <input statetype='login-container--input_checkbox' classtype='login-container--input_checkbox' type="checkbox" value="Default checkbox" id="flexCheckDefault" class="form-check-input login-container--input_checkbox"/>
                    <label for="flexCheckDefault" class="form-check-label">Remember me</label>
                    </div>
                    <a class="pointer" href="">Forgot password?
                    </a>
                </div>
                <button classtype='login-container--button' class="p-2 pointer w-50 my-4 login-container--button border-0">Login
                </button>
                </div>
                
            </div>
        </div>   
        `
    })
};

export default login3;